import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireSuperAdmin?: boolean;
  requireHostelAdmin?: boolean;
  requireStaff?: boolean;
  /** If true, super admins are redirected (e.g. hostel-only flows like manual invoice create) */
  blockSuperAdmin?: boolean;
  /** If true, hostel admins (non–super-admin) are redirected */
  blockHostelAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAdmin = false,
  requireSuperAdmin = false,
  requireHostelAdmin = false,
  requireStaff = false,
  blockSuperAdmin = false,
  blockHostelAdmin = false,
}) => {
  const { 
    user, 
    loading, 
    isAdmin, 
    isSuperAdmin, 
    isHostelAdmin, 
    isStaff 
  } = useAuth();

  if (loading) {
    return <div className="loading-container">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireSuperAdmin && !isSuperAdmin?.()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireHostelAdmin && !isHostelAdmin?.() && !isSuperAdmin?.()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireStaff && !isStaff?.() && !isHostelAdmin?.() && !isSuperAdmin?.()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (blockSuperAdmin && isSuperAdmin?.()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (blockHostelAdmin && isHostelAdmin?.() && !isSuperAdmin?.()) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;

